import { Link } from 'react-router-dom';

export function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0f0a15921132d1f138d84e40566dcd13.jpg"
          alt="ZEPHYRION Kitchen"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/20" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-500/40 rounded-full px-4 py-1.5 mb-6">
            <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" />
            <span className="text-amber-300 text-xs font-medium tracking-wider uppercase">Premium Kitchen & Dining</span>
          </div>

          <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Elevate Your<br />
            <span className="text-amber-400">Culinary</span><br />
            Experience
          </h1>

          <p className="text-white/75 text-lg leading-relaxed mb-8 max-w-lg">
            Discover premium kitchen & dining essentials crafted for the modern home. From professional cookware to elegant dinnerware — everything you need to cook and entertain beautifully.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-xl font-semibold transition-all hover:scale-105 whitespace-nowrap"
            >
              Shop Collection
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 border border-white/50 hover:border-white text-white px-8 py-4 rounded-xl font-semibold transition-all hover:bg-white/10 whitespace-nowrap"
            >
              Our Story
            </Link>
          </div>

          <div className="flex items-center gap-8 mt-12">
            {[
              { num: '2,000+', label: 'Products' },
              { num: '50K+', label: 'Happy Customers' },
              { num: '98%', label: 'Satisfaction' },
            ].map(stat => (
              <div key={stat.label}>
                <p className="text-2xl font-bold text-amber-400" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.num}</p>
                <p className="text-white/60 text-xs mt-0.5">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-wider">SCROLL</span>
        <i className="ri-arrow-down-line text-white/50" />
      </div>
    </section>
  );
}
